import type { ReactNode } from 'react'
import React from 'react'

import type { TagProps } from '@fourthwall/components'
import { BaseContent, Tag } from '@fourthwall/components'

import * as S from './ConnectionsGrid.styled'

type ConnectionsGridProps = {
  items: {
    id: string
    title: string
    description: ReactNode
    thumbnail: string
    tag: Pick<TagProps, 'label' | 'appearance'> | undefined
    type?: 'beta' | 'thirdParty' | 'draft' | 'community'
    to: string
  }[]
}

export const ConnectionsGrid = ({ items }: ConnectionsGridProps) => (
  <S.Container>
    {items.map((item) => (
      <S.ItemContainer to={item.to} id={item.id}>
        <S.ItemThumbnail src={item.thumbnail} alt={`${item.title} logo`} />
        <S.ItemTitle>{item.title}</S.ItemTitle>
        <S.ItemDescription>
          <BaseContent size="small" appearance="secondary">
            {item.description}
          </BaseContent>
        </S.ItemDescription>
        {item.tag && (
          <S.ItemTagContainer>
            <Tag {...item.tag} />
          </S.ItemTagContainer>
        )}
        {item.type === 'beta' && (
          <S.ItemTypeTagContainer>
            <Tag label="Beta" appearance="alert" />
          </S.ItemTypeTagContainer>
        )}
        {item.type === 'community' && (
          <S.ItemTypeTagContainer>
            <Tag label="Community" appearance="alert" />
          </S.ItemTypeTagContainer>
        )}
        {item.type === 'draft' && (
          <S.ItemTypeTagContainer>
            <Tag label="Draft" />
          </S.ItemTypeTagContainer>
        )}
        {item.type === 'thirdParty' && (
          <S.ItemTypeTagContainer>
            <Tag label="Third Party" appearance="default" />
          </S.ItemTypeTagContainer>
        )}
      </S.ItemContainer>
    ))}
  </S.Container>
)
